import {
  Component,
  ElementRef,
  inject,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ValueListItemDTO } from "src/app/Common/ValueListService/value-list-item.interface";
import { ValueListService } from "src/app/Common/ValueListService/value-list.service";
import { UserLoginService } from "src/app/login/userlogin.service";
import { LoanRequestService } from "src/app/School/BackOffice/loan-request/loan-request.service";
import { ToastrService } from "ngx-toastr";
import { EmiOption } from "../Interface & Service/payment-options/payment-options.interface";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ProductsService } from "../Interface & Service/product/products.service";
import {
  LoanSlab,
  LoanSlabRequestDTO,
  ProductDTO,
  ProductReadByProductCodeRequestDTO,
} from "../Interface & Service/product/product.interface";
import { QuickLoanData } from "../quick-loan-process/quick-loan.interface";
import { firstValueFrom, Subject, takeUntil } from "rxjs";
import { RoundoffSavingsService } from "../Interface & Service/round-off-savings/roundoff-savings.service";
import {
  RoundOffAmountFetchRequest,
  RoundOffAmountFetchResponse,
} from "../Interface & Service/round-off-savings/roundoff-savings.interface";
import { RazorpayServices } from "../razorpay/razorpay.services";
import { GetAmountByPRRNDTO } from "../razorpay/razorpay.interface";
import { GetAmountByPRRNResponseDTO } from "../receipt-master/receiptMaster.interface";
import { PaylaterReceiptMasterService } from "../receipt-master/receiptMaster.service";
import { LoanApplicationService } from "../loan-applications/loan-applications.service";
import {
  LoanApplicationCreateDTO,
  LoanApplicationItem,
} from "../loan-applications/loan-applications.interface";
import { ApplicationDetailsService } from "../loan-applications/loan-application-details/loan-application-details.service";
import { ApplicationDetailsCreateByParametersRequest } from "../loan-applications/loan-application-details/loan-application-details.interface";
import { SchoolInvoiceMasterService } from "src/app/School/EndUser/receipt-master/receipt-master.service";
import { SchoolInvoiceMasterDeleteRequestDTO, SchoolInvoiceMasterDTO, SchoolInvoiceMasterReadAllPaginatedRequestDTO, SchoolInvoiceMasterUpdateRequestDTO } from "src/app/School/EndUser/receipt-master/receipt-master.interface";
import { SM_SocietyInvoiceMasterService } from "src/app/housing-society/Interface & Service/invoice-master/invoice-master.service";
import { HospitalInvoiceMasterService } from "src/app/hospital/BackOffice/hospital-master/hospital-detail/hospital-billing/hospital-billing.service";
import { HospitalInvoiceMasterDTO, HospitalInvoiceMasterReadAllPaginatedRequestDTO, HospitalInvoiceMasterUpdateRequestDTO } from "src/app/hospital/BackOffice/hospital-master/hospital-detail/hospital-billing/hospital-billing.interface";
import { LoanRequestDTO } from "src/app/School/BackOffice/loan-request/loan-request.interface";
import { dynamicEnvironment } from "src/app/Common/DynamicEnvironment/DynamicEnvironment";

@Component({
  selector: "app-payment-options",
  templateUrl: "./payment-options.component.html",
  styleUrls: ["./payment-options.component.css"],
})
export class PaymentOptionsComponent {
  toastr = inject(ToastrService);
  User = inject(UserLoginService).User();
  router = inject(Router);
  valuelistService = inject(ValueListService);
  productService = inject(ProductsService);
  loanRequestService = inject(LoanRequestService);
  roundOffService = inject(RoundoffSavingsService);
  modalService = inject(NgbModal);
  route = inject(ActivatedRoute);
  RazorPayService = inject(RazorpayServices);
  PaylaterReceiptMasterServices = inject(PaylaterReceiptMasterService);

  private SchoolInvoiceMasterService = inject(SchoolInvoiceMasterService);
  private SocietyInvoiceMasterService = inject(SM_SocietyInvoiceMasterService);
  private HospitalInvoiceMasterService = inject(HospitalInvoiceMasterService);

  razorpayServices = inject(RazorpayServices);
  loanApplicationServices = inject(LoanApplicationService);
  ApplicationDetailService = inject(ApplicationDetailsService);
  QRModalRef!: NgbModalRef;
  @ViewChild("QRModal") qrModal!: TemplateRef<any>;
  @ViewChild("roundOffModal") roundOffModal!: TemplateRef<any>;

  userId: number = this.User?.userId || 0;
    returnUrl: string = "";
  isLoading = false;
  paymentMode: "PARTIAL" | "FULL" = "PARTIAL";
  partialAmount: number = 0;
  selectedPaymentMethod: string = "CASH";
  roundOffAmount: number = 0;
  private destroy$ = new Subject<void>();
  loanProduct: ProductDTO | null = null;
  loanRawUrl: ValueListItemDTO[] = [];
  loanApplicationResponse: LoanApplicationItem | null = null;
  quickLoanData: QuickLoanData = {
    prrn: "",
    userId: 0,
    subUserId: 0,
    businessId: 0,
    loanamt: 0,
    productcode: "",
    moduleName: "",
    emiTenure: 0,
  };
  paymentLabels: Record<string, string> = {
    UPI: "UPI",
    BANK: "Net Banking",
    CARD: "Credit / Debit Card",
  };
  selectedQRData: string = "";
  getByPRRNItemData!: GetAmountByPRRNResponseDTO;
  getByPRRNItemData2!: GetAmountByPRRNResponseDTO;
  receiptAmount: number = 0;
  loanSlabs: LoanSlab[] = [];
  monthColumns: string[] = [];
  selectedMonth: string | null = null;
  isLoanSlabLoaded: boolean = true;
  iconMap: { [key: string]: string } = {
    Amount: "fa-money-bill-wave",
    Interest: "fa-chart-line",
    EMI: "fa-credit-card",
    "Total Payable": "fa-file-invoice-dollar",
  };

  hospitalInvoiceMasterData: HospitalInvoiceMasterDTO | null = null;
  schoolInvoiceMasterData: SchoolInvoiceMasterDTO | null = null;
  invoiceModuleName: "hospital" | "school" | "society" | null = null;
  isInvoiceAlreadyPaid: boolean = false;
  invoiceAmount:number = 0;

  isCashPaymentConfirmationModalOpen: boolean = false;

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        // If prrn is missing → set params and exit this cycle
        // if (!params["productcode"]) {
        //   this.router.navigate([], {
        //     relativeTo: this.route,
        //     queryParams: {
        //       prrn: "SPE00000000000001",
        //       userId: 1042,
        //       subUserId: 36,
        //       businessId: 1024,
        //       loanamt: 24500,
        //       productcode: "SchoolPay",
        //       moduleName: "School",
        //       emiTenure: this.selectedMonth,
        //     },
        //     queryParamsHandling: "merge",
        //   });
        //   return;
        // }
        if (!params["productcode"]) {
  return; 
}

        this.quickLoanData = {
          prrn: params["prrn"] ?? 0,
          userId: params["userId"] ?? 0,
          subUserId: params["subUserId"] ?? 0,
          businessId: params["businessId"] ?? 0,
          loanamt: params["loanamt"] ?? 0,
          productcode: params["productcode"] ?? "",
          moduleName: params["moduleName"] ?? "",
          emiTenure: params["emiTenure"] ?? 0,
        };

        this.getLoanInfoByPrrnAndModule(params["prrn"] as string, params["businessId"] as number, params["moduleName"] as string);
        if (this.quickLoanData.moduleName.toLowerCase() === "hospital") {
          this.getHospitalInvoiceByPRRN();
        }else if(this.quickLoanData.moduleName.toLowerCase() === "school") {
          this.getSchoolInvoiceByPRRN();
        };
      });
  }

  // async ngOnDestroy() {
  //   // console.log(this.quickLoanData)
  //   const data: GetAmountByPRRNDTO = {
  //     prrn: this.quickLoanData.prrn,
  //     // prrn: 'SPE00000000000001',                    //for testing purpose
  //     moduleName: this.quickLoanData.moduleName.toLowerCase(),
  //   };
  //   const res = await firstValueFrom(
  //     this.PaylaterReceiptMasterServices.ReceiptMaster_GetAmountByPRRN(data),
  //   );
  //   this.getByPRRNItemData = res;
  //   console.log(this.getByPRRNItemData);

  //   const deleteData: SchoolInvoiceMasterDeleteRequestDTO = {
  //     invoiceId: this.getByPRRNItemData.InvoiceId ?? 0,
  //     actionUser: this.User?.userId?.toString() || '0',
  //   };

  //   const moduleName = this.getByPRRNItemData.ModuleName;
  //   if (this.getByPRRNItemData2.RStatus?.toLowerCase() === "pending") {
  //     if (moduleName === "school") {
  //       await firstValueFrom(
  //         this.SchoolInvoiceMasterService.SchoolInvoiceMaster_Delete(
  //           deleteData,
  //         ),
  //       );
  //     } else if (moduleName === "housingsociety") {
  //       // await firstValueFrom(this.SocietyInvoiceMasterService.ReceiptMaster_Delete(deleteData))
  //     } else if (moduleName === "hospital") {
  //       // await firstValueFrom(this.SocietyInvoiceMasterService.ReceiptMaster_Delete(deleteData))
  //       console.log("need to implement the delete logic for hospital");
  //     } else if (moduleName === "realestate") {
  //       // await firstValueFrom(this.SocietyInvoiceMasterService.ReceiptMaster_Delete(deleteData))
  //       console.log("need to implement the delete logic for realestate");
  //     }
  //   }
  // }
  ngOnDestroy() {
  this.destroy$.next();
  this.destroy$.complete();
}

  activeTab: string = "CASH";
  emiAmount: number = 0;

  selectPayment(method: string) {
    this.selectedPaymentMethod = method;
    this.activeTab = method; // 🔥 THIS CONTROLS UI

    if (method === "NISHWIK") {
      this.scrollToEmiSection();
      this.prepareEmiCalculation();
    }
  }
  get finalAmount(): number {
    return this.manualAmount > 0
      ? this.manualAmount
      : this.quickLoanData.loanamt;
  }
  manualAmount: number = 0;
  manualInterest: number = 0;
  manualDiscount: number = 0;

  handlePayment() {
  if (Number(this.payableAmountForPayment || 0) <= 0) {
    this.goBack();
    return;
  }
    switch (this.selectedPaymentMethod) {
      case "UPI":
        this.payWithUpi();
        break;

      case "CREDIT":
      case "DEBIT":
        if (
          !this.cardDetails.number ||
          !this.cardDetails.expiry ||
          !this.cardDetails.cvv
        ) {
          this.toastr.error("Please fill card details");
          return;
        }
        this.toastr.success("Card Payment Successful");
        break;


      case "CASH":
        this.handleCashPayment();
        break;


      case "NISHWIK":
        // this.getLoan();
        this.createLoanApplication();
        break;
    }
  }

  @ViewChild("emiSection") emiSection!: ElementRef;

  scrollToEmiSection() {
    setTimeout(() => {
      this.emiSection.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 200);
  }

  prepareEmiCalculation() {
    if (!this.monthColumns || this.monthColumns.length === 0) return;

    this.selectedMonth = this.monthColumns[0]; // ✅ auto select
  }

  calculateEmi() {
    if (!this.selectedMonth) return;

    const months = +this.selectedMonth;
    const principal = this.quickLoanData.loanamt;

    const annualRate = 12;
    const monthlyRate = annualRate / 12 / 100;

    const emi =
      (principal * monthlyRate * Math.pow(1 + monthlyRate, months)) /
      (Math.pow(1 + monthlyRate, months) - 1);

    this.emiAmount = parseFloat(emi.toFixed(2));
  }

  cardDetails = {
    number: "",
    expiry: "",
    cvv: "",
  };

  cashDetails = {
    name: "",
    amount: 0,
  };

  getFinalAmount() {
    return (
      this.manualAmount +
      (this.manualAmount * this.manualInterest) / 100 -
      (this.manualAmount * this.manualDiscount) / 100
    );
  }

  getLoanProductDetail() {
    this.isLoading = true;
    let payload: ProductReadByProductCodeRequestDTO = {
      productCode: this.quickLoanData.productcode,
    };
    this.productService.Product_ReadByProductCode(payload).subscribe({
      next: (data) => {
        this.loanProduct = data;
        this.isLoading = false;
        this.calculateEMIs(this.roundOffAmount, data.interestRate);
        this.GetLoanSlabs(data.interestRate);
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
      },
    });
  }
  get remainingAmount(): number {
    return this.roundOffAmount - (this.partialAmount || 0);
  }

  isAmountWithinLoanLimits(): boolean {
    if (!this.selectedMonth) {
      return false;
    }
    return (
      // this.remainingAmount >= this.loanProduct.minLoanAmount &&
      true
      // this.remainingAmount <= this.loanProduct.maxLoanAmount
    );
  }

  getCurrentLocation(): Promise<{ latitude: number; longitude: number }> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported by your browser."));
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          resolve({ latitude, longitude });
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  createLoanApplication() {
    if(!this.hospitalInvoiceMasterData) return;

    const payload: LoanApplicationCreateDTO = {
      userId: this.hospitalInvoiceMasterData.billedTo,
      productId: this.loanProduct?.productId ?? 0,
      applicationStatus: "Initiated",
      requestedAmount: this.hospitalInvoiceMasterData.invoiceAmount ?? 0,
      approvedAmount: 0,
      tenureMonths: Number(this.selectedMonth),
      applicationDate: new Date(),
      approvalDate: null,
      approvedBy: "",
      rejectionReason: "",
      rejectedBy: "",
      isDisbursed: 0,
      disbursedOn: undefined,
      disbursedAmount: 0,
      subUserId: this.quickLoanData.subUserId,
      businessId: this.hospitalInvoiceMasterData.hospitalId,
      productCode: this.loanProduct?.productCode ?? "",
      otherDetail1: this.quickLoanData.moduleName,
      actionUser: this.User?.userId?.toString() || '0',
      prrn: this.hospitalInvoiceMasterData.prrn,
      lmsApplicationName: "",
    };

    this.loanApplicationServices.LoanApplication_Create(payload).subscribe({
      next: (res) => {
        this.loanApplicationResponse = res;
        this.createByParameters();
      },
    });
    // .toPromise()
    // .catch(err => {
    //   console.error('LoanApplication_Create failed', err);
    //   throw err;
    // });
  }

  createByParameters() {
    const payload: ApplicationDetailsCreateByParametersRequest = {
      applicationId: this.loanApplicationResponse?.applicationId ?? 0,
      occupationType: "",
      actionUser: this.User?.userId?.toString() || '0',
    };
    this.ApplicationDetailService.ApplicationDetails_CreateByParameters(
      payload,
    ).subscribe({
      next: (res) => {
        const redirectUrl = `${dynamicEnvironment.websiteURL}/quick-loan?ApplicationId=${this.loanApplicationResponse?.applicationId}`;
        window.open(redirectUrl, "_self");
      },
      error: (err) => {
        console.log("createByParameters errors: ", err);
      },
    });
  }

  // async getLoan(): Promise<void> {
  //   this.isLoading = true;

  //   if(!this.hospitalInvoiceMasterData) return;

  //   try {
  //     // const loanAppResponse = await this.createLoanApplication();
  //     // console.log('Loan application created:', loanAppResponse);

  //     // const applicationId = await this.createLoanApplication();
  //     const location = await this.getCurrentLocation();

  //     const ipData = await fetch("https://api.ipify.org?format=json").then(
  //       (res) => res.json(),
  //     );
  //     const loanRequestPayload = {
  //       userId: this.hospitalInvoiceMasterData.billedTo,
  //       subUserId: this.quickLoanData.subUserId,
  //       businessId: this.hospitalInvoiceMasterData.hospitalId,
  //       loanAmount: this.hospitalInvoiceMasterData.invoiceAmount,
  //       productType: this.quickLoanData.productcode,
  //       purpose: "",
  //       currencyCode: "INR",
  //       deviceType: "Web",
  //       deviceName: window.navigator.userAgent,
  //       ipAddress: ipData.ip,
  //       geoLatitude: location.latitude,
  //       geoLongitude: location.longitude,
  //       status: "Pending",
  //       loanProviderRRN: "",
  //       loanProviderTxnId: "",
  //       requestDate: new Date(),
  //       responseDate: new Date(),
  //       actionUser: this.userId.toString(),
  //       otherDetail1: (this.partialAmount ?? 0).toString(),
  //       otherDetail2: this.selectedPaymentMethod,
  //       otherDetail3: "",
  //       otherDetail4: "",
  //       otherDetail5: "",
  //       otherDetail6: "",
  //     };

  //     this.loanRequestService.LoanRequest_Create(loanRequestPayload).subscribe({
  //     next: (response: LoanRequestDTO) => {
  //     const valuelistPayload = {
  //       vlCode: "SPE_QuickLoanUrl",
  //     };

  //     this.valuelistService
  //       .ValueListItem_readByVlCode(valuelistPayload)
  //       .subscribe({
  //         next: (vlData) => {
  //           this.loanRawUrl = vlData.items;

  //           if (this.loanRawUrl.length > 0) {
  //             const baseUrl = this.loanRawUrl[0].vliCode;

  //             const queryParams = new URLSearchParams({
  //               prrn: this.quickLoanData.prrn,
  //               moduleName: String(this.quickLoanData.moduleName ?? ""),
  //               applicationId: String(
  //                 this.loanApplicationResponse?.applicationId,
  //               ),
  //             });
  //             // const redirectUrl = `${baseUrl}?${queryParams.toString()}`;
  //             // window.open(redirectUrl, "_self");
  //           }

  //           this.isLoading = false;
  //         },
  //         error: (vlErr) => {
  //           console.error("Error fetching loan redirect URL:", vlErr);
  //           this.isLoading = false;
  //         },
  //       });
  //     },
  //     error: (err) => {
  //       console.error('LoanRequestCreate failed:', err);
  //       this.isLoading = false;
  //     }
  //     });
  //   } catch (error) {
  //     console.error("❌ Failed to get location or IP:", error);
  //     this.isLoading = false;
  //   }
  // }

  applyForLoan() {
    if (!this.selectedMonth) {
      this.toastr.warning("Please select an EMI plan first.");
      return;
    }
    // this.getLoan();
    this.createLoanApplication();
  }

  EmiPay() {
    if (this.selectedEmi) {
      this.toastr.success(`Payment initiated via Nishwik EMI: ${this.upiId}`);

      setTimeout(() => {
        this.selectedEmi = null;
      }, 500);
    } else {
      this.toastr.warning("Please select an EMI plan first.");
    }
  }
  bankList: string[] = ["HDFC Bank", "ICICI Bank", "SBI", "Axis Bank", "Kotak"];
  selectedBank: string = "";
  netBankUserId: string = "";
  netBankPassword: string = "";
  processNetBankingPayment() {
    if (!this.selectedBank || !this.netBankUserId || !this.netBankPassword) {
      this.toastr.error("Please fill all required fields.");
      return;
    }
    this.toastr.success(`Payment initiated through ${this.selectedBank}`);
  }

  upiId: string = "";
  upiVerified: boolean = false;
  upiError: boolean = false;

  verifyUpi() {
    this.upiVerified = false;
    this.upiError = false;

    if (!this.upiId || this.upiId.trim() === "") {
      this.upiError = true;
      return;
    }

    // ✅ UPI REGEX (basic validation)
    const upiRegex = /^[a-zA-Z0-9.\-_]{2,}@[a-zA-Z]{2,}$/;

    if (upiRegex.test(this.upiId)) {
      this.upiVerified = true;
      this.upiError = false;
    } else {
      this.upiVerified = false;
      this.upiError = true;
    }
  }

  finalPaymentAmount: number = 0;

  payWithUpi() {
    if (!this.upiId || !this.manualAmount) {
      alert("Please enter UPI ID and Amount");
      return;
    }

    const payeeVpa = this.upiId; // receiver UPI ID
    const payeeName = "Nishwik"; // your app/company name
    const amount = this.manualAmount;
    const note = "Payment via Nishwik";

    // ✅ UPI LINK
    const upiUrl = `upi://pay?pa=${payeeVpa}&pn=${payeeName}&am=${amount}&cu=INR&tn=${note}`;

    // ✅ OPEN UPI APP
    window.location.href = upiUrl;
  }

  emiOptions: EmiOption[] = [];
  selectedEmi: EmiOption | null = null;

  calculateEMIs(principalAmount: number, interestRate: number) {
    const monthlyRate = interestRate / 12 / 100;
    const durations = [3, 6, 9, 12, 24, 36];

    this.emiOptions = durations.map((duration) => {
      const emi = this.calculateEMI(principalAmount, monthlyRate, duration);
      const totalAmount = emi * duration;
      return {
        duration,
        emiAmount: Math.round(emi),
        totalAmount: Math.round(totalAmount),
      };
    });

    this.selectedEmi = null;
  }

  calculateEMI(
    principal: number,
    monthlyRate: number,
    tenureMonths: number,
  ): number {
    if (monthlyRate === 0) return principal / tenureMonths;
    return (
      (principal * monthlyRate * Math.pow(1 + monthlyRate, tenureMonths)) /
      (Math.pow(1 + monthlyRate, tenureMonths) - 1)
    );
  }

  /*RoundOff API Starts Here */
  fetchRoundOffAmountRequest: RoundOffAmountFetchRequest = {
    totalAmount: 0,
    userId: this.User?.userId || 0,
  };
  RoundOffAmountDetailsResponse: RoundOffAmountFetchResponse = {
    totalAmount: 0,
    userId: this.User?.userId || 0,
    isRoundOffEnabled: 0,
    roundOffAmount: 0,
    finalPayableAmount: 0,
  };
  fetchRoundOffAmountFlag: boolean = false;

  RoundOffAmountFetch(requestDTO: RoundOffAmountFetchRequest) {
    this.fetchRoundOffAmountFlag = true;
    this.fetchRoundOffAmountRequest.totalAmount =
      this.quickLoanData.loanamt ?? 0;
    this.roundOffService
      .RoundOffSavings_RoundOffAmountFetch(requestDTO)
      .subscribe({
        next: (res: RoundOffAmountFetchResponse) => {
          if (res) {
            this.roundOffAmount = res.finalPayableAmount;
            this.RoundOffAmountDetailsResponse = res;
            this.fetchRoundOffAmountFlag = false;
            this.getLoanProductDetail();
          }
        },
        error: (err) => {
          this.fetchRoundOffAmountFlag = false;
          console.error(" Failed to fetch product type:", err);
        },
      });
  }
  public OpenSmartVaultModal() {
    this.modalService.open(this.roundOffModal, {
      size: "lg",
      scrollable: true,
    });
  }

  HandleRoundOffEventEmit() {
    this.modalService.dismissAll();
    this.fetchRoundOffAmountRequest.totalAmount =
      this.quickLoanData.loanamt ?? 0;
    this.RoundOffAmountFetch(this.fetchRoundOffAmountRequest);
  }

  // getAmountByPRRNData() {
  //   const data: GetAmountByPRRNDTO = {
  //     prrn: this.quickLoanData.prrn,
  //     moduleName: this.quickLoanData.moduleName.toLowerCase(),
  //   };
  //   this.PaylaterReceiptMasterServices.ReceiptMaster_GetAmountByPRRN(
  //     data,
  //   ).subscribe({
  //     next: (response) => {
  //       this.isLoanSlabLoaded = false;
  //       this.getByPRRNItemData2 = response;
  //       this.receiptAmount =
  //         response.ReceiptAmount ?? response.InvoiceAmount ?? 0;
  //       this.quickLoanData.loanamt = this.receiptAmount;

  //       this.fetchRoundOffAmountRequest.totalAmount = this.receiptAmount;
  //       this.RoundOffAmountFetch(this.fetchRoundOffAmountRequest);
  //     },
  //     error: (err) => {
  //       console.error("Error fetching the Amount: ", err);
  //       this.isLoanSlabLoaded = false;
  //     },
  //   });
  // }

  getLoanInfoByPrrnAndModule(
    prrn: string,
    businessId: number,
    moduleName: string,
  ) {
    if (!prrn || !businessId || !moduleName) {
      this.router.navigate(["/PageNotFound"]);
    }

    if(moduleName === "hospital") {
      this.getHospitalInvoiceInfo(prrn, businessId);
    }
  }

  getHospitalInvoiceInfo(prrn: string, businessId: number) {
    const readAllPaginatedData: HospitalInvoiceMasterReadAllPaginatedRequestDTO =
      {
        hospitalId: businessId,
        pageNo: 1,
        pageSize: 10,
        whereClause: `prrn=${prrn}`,
        orderByClause: "",
      };

    this.HospitalInvoiceMasterService.HospitalInvoiceMaster_ReadAllPaginated(
      readAllPaginatedData,
    ).subscribe({
      next: (res) => {
      if(res.items.length == 0) {
        this.router.navigate(["/PageNotFound"]);
      }else {
        this.hospitalInvoiceMasterData = res.items[0];
        
        this.quickLoanData["prrn"] = res.items[0].prrn;
        this.quickLoanData["userId"] = res.items[0].billedTo;
        this.quickLoanData["businessId"] = res.items[0].hospitalId;
        this.quickLoanData["loanamt"] = res.items[0].invoiceAmount;
        this.quickLoanData["moduleName"] = "hospital";
        this.isInvoiceAlreadyPaid = res.items[0].status === "Paid";
      }
    }, error: (err) => {
      console.log(err);
    }
    });
  };

  //GetLoanSlabs

  GetLoanSlabs(interestRate: number) {

    const data: LoanSlabRequestDTO = {
      principal:
        this.invoiceAmount ??
        0,
      annualRatePct: interestRate,
      durationsCsv: "3,6,9,12",
    };

    this.productService.Product_GetLoanSlabs(data).subscribe({
      next: (response) => {
        this.loanSlabs = response.loanSlabs;

        if (this.loanSlabs.length > 0) {
          // Extract all keys except "RowLabel"
          this.monthColumns = Object.keys(this.loanSlabs[0]).filter(
            (k) => k !== "RowLabel",
          );
        }
        this.isLoanSlabLoaded = false;
      },
      error: (err) => {
        console.error("Error fetching loan slabs:", err);
        this.isLoanSlabLoaded = false;
      },
    });
  }

  selectEmiOption(month: string): void {
    this.selectedMonth = month;
  }

  getValue(rowLabel: string, key: string): any {
    const row = this.loanSlabs.find((slab) => slab.RowLabel === rowLabel);
    return row ? row[key] : 0;
  }

  // QR CODE
  downloadQR() {
    //   const qrData = JSON.parse(this.selectedQRData);
    //   const driverSection = qrData.drivers.length
    //     ? `
    //     <table>
    //       <tr>
    //         <th>Driver Name</th>
    //         <th>Mobile No</th>
    //         <th>Route Name</th>
    //         <th>Shift</th>
    //         <th>Primary Driver</th>
    //       </tr>
    //       ${qrData.drivers
    //       .map((d: any) => {
    //         const startDate = d.startDate
    //           ? new Date(d.startDate).toLocaleDateString('en-GB')
    //           : '-';
    //         const endDate = d.endDate
    //           ? new Date(d.endDate).toLocaleDateString('en-GB')
    //           : '-';
    //         return `
    //             <tr>
    //               <td>${d.driverName}</td>
    //               <td>${d.mobileNo}</td>
    //               <td>${d.routeName}</td>
    //               <td>${d.shift}</td>
    //               <td>${d.isPrimary ? 'Yes' : 'No'}</td>
    //             </tr>`;
    //       })
    //       .join('')}
    //     </table>`
    //     : `<p style="color: #dc3545; font-weight: 600; text-align: center; margin: 10px 0;">
    //        No driver is assigned to this vehicle.
    //      </p>`;
    //   const htmlContent = `
    //   <html>
    //     <head>
    //       <title>Vehicle QR Details</title>
    //       <style>
    //         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');
    //         body { font-family: 'Inter', sans-serif; background: #eef2f7; margin: 0; padding: 30px; }
    //         .container { max-width: 800px; margin: auto; background: white; border-radius: 12px; padding: 25px; box-shadow: 0 4px 20px rgba(0,0,0,0.1); }
    //         h1 { text-align: center; color: #007bff; margin-bottom: 20px; }
    //         .section-title { color: #444; font-size: 18px; margin-top: 20px; margin-bottom: 8px; font-weight: 600; }
    //         table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
    //         th, td { padding: 10px; border: 1px solid #ddd; font-size: 14px; }
    //         th { background: #007bff; color: white; text-align: left; }
    //         td { background: #f9f9f9; }
    //         .footer { text-align: center; font-size: 12px; color: #888; margin-top: 20px; }
    //       </style>
    //     </head>
    //     <body>
    //       <div class="container">
    //         <h1>Vehicle QR Details</h1>
    //         <div class="section">
    //           <div class="section-title">Vehicle Information</div>
    //           <table>
    //             <tr><th>Vehicle No</th><td>${qrData.vehicle.vehicleNo}</td></tr>
    //             <tr><th>Type</th><td>${qrData.vehicle.type}</td></tr>
    //             <tr><th>Chassis No</th><td>${qrData.vehicle.chassisNo}</td></tr>
    //             <tr><th>Capacity</th><td>${qrData.vehicle.capacity}</td></tr>
    //             <tr><th>Status</th><td>${qrData.vehicle.status}</td></tr>
    //           </table>
    //         </div>
    //         <div class="section">
    //           <div class="section-title">Driver Information</div>
    //           ${driverSection}
    //         </div>
    //         <div class="footer">
    //           Generated on ${new Date().toLocaleString()}
    //         </div>
    //       </div>
    //     </body>
    //   </html>
    // `;
    //   const newWindow = window.open('', '_blank');
    //   if (newWindow) {
    //     newWindow.document.write(htmlContent);
    //     newWindow.document.close();
    //   }
  }

  getHospitalInvoiceByPRRN() {
    const payload: HospitalInvoiceMasterReadAllPaginatedRequestDTO = {
      hospitalId: this.quickLoanData.businessId, // or correct hospitalId
      pageSize: 1,
      pageNo: 1,
      orderByClause: "invoiceId desc",
      whereClause: `prrn=${this.quickLoanData.prrn}`,
    };

    this.HospitalInvoiceMasterService.HospitalInvoiceMaster_ReadAllPaginated(
      payload,
    ).subscribe({
      next: (res) => {
        if (res.items && res.items.length > 0) {
          this.hospitalInvoiceMasterData = res.items[0];
          this.invoiceAmount = res.items[0].invoiceAmount;
          this.invoiceModuleName = "hospital";
          this.getLoanProductDetail();
        }
      },
      error: (err) => {
        console.error("Error fetching invoice by PRRN", err);
      },
    });
  }

  // getSchoolInvoiceByPRRN() {
  // const payload: SchoolInvoiceMasterReadAllPaginatedRequestDTO = {
  //   schoolId: Number(this.quickLoanData.businessId || 0),
  //   pageSize: 1,
  //   pageNo: 1,
  //   orderByClause: "invoiceId desc",
  //   whereClause: `prrn='${this.quickLoanData.prrn}'`,
  // };
  getSchoolInvoiceByPRRN() {
  const payload: SchoolInvoiceMasterReadAllPaginatedRequestDTO = {
    schoolId: Number(this.quickLoanData.businessId || 0),
    pageSize: 1,
    pageNo: 1,
    orderByClause: "PrimaryDesc",
    prrn: this.quickLoanData.prrn,
  };

  this.SchoolInvoiceMasterService
    .SchoolInvoiceMaster_ReadAllPaginated(payload)
    .subscribe({
      next: (res) => {
        if (res.items && res.items.length > 0) {
          this.schoolInvoiceMasterData = res.items[0];
          this.invoiceAmount = res.items[0].invoiceAmount;
          this.invoiceModuleName = "school";
          this.isInvoiceAlreadyPaid =
            res.items[0].status === "Paid";

          this.getLoanProductDetail();
        }
      },
      error: (err) => {
        console.error("Error fetching school invoice by PRRN", err);
      },
    });
}

  updateHospitalInvoiceStatus() {
    if (!this.hospitalInvoiceMasterData) {
      this.toastr.error("Invoice not found");
      return;
    }

    const payload = {
      invoiceId: this.hospitalInvoiceMasterData.invoiceId,
      hospitalId: this.hospitalInvoiceMasterData.hospitalId,
      billedTo: this.hospitalInvoiceMasterData.billedTo,
      invoiceDate: this.hospitalInvoiceMasterData.invoiceDate,
      invoiceAmount: this.hospitalInvoiceMasterData.invoiceAmount,
      checkInTime: this.hospitalInvoiceMasterData.checkInTime,
      checkOutTime: this.hospitalInvoiceMasterData.checkOutTime,
      patientType: this.hospitalInvoiceMasterData.patientType,
      gst: this.hospitalInvoiceMasterData.gst ?? 0,
      status: "Paid",
      isActive: this.hospitalInvoiceMasterData.isActive ?? 1,
      actionUser: this.User.userId.toString(),
      dueDate: this.hospitalInvoiceMasterData.dueDate,
      paymentMode:"CASH"
    };

    this.HospitalInvoiceMasterService.HospitalInvoiceMaster_Update(
      payload,
    ).subscribe({
      next: () => {
        this.getHospitalInvoiceByPRRN();
      },
      error: (err) => {
        console.error("Error updating invoice", err);
        this.toastr.error("Payment update failed");
      },
    });
  }


    handleCashPayment(): void {
    // if (!this.cashDetails.name || this.cashDetails.name.trim() === "") {
    //   this.toastr.error("Please enter the patient / payer name.");
    //   return;
    // }

    const isHospital = this.quickLoanData.moduleName?.toLowerCase() === "hospital";
    const isSchool = this.quickLoanData.moduleName?.toLowerCase() === "school";
    if (isHospital && this.hospitalInvoiceMasterData) {
      this.isLoading = true;

      const payload: HospitalInvoiceMasterUpdateRequestDTO = {
        invoiceId: this.hospitalInvoiceMasterData.invoiceId,
        hospitalId: this.hospitalInvoiceMasterData.hospitalId,
        billedTo: this.hospitalInvoiceMasterData.billedTo,
        invoiceDate: this.hospitalInvoiceMasterData.invoiceDate,
        invoiceAmount: this.hospitalInvoiceMasterData.invoiceAmount,
        checkInTime: this.hospitalInvoiceMasterData.checkInTime,
        checkOutTime: this.hospitalInvoiceMasterData.checkOutTime ??new Date(),
        gst: this.hospitalInvoiceMasterData.gst ?? 0,
        status: "Paid",
        dueDate: this.hospitalInvoiceMasterData.dueDate,
        paymentMode:"Cash",
        patientType: this.hospitalInvoiceMasterData.patientType,
        otherDetail1: this.hospitalInvoiceMasterData.otherDetail1,
        otherDetail2: this.hospitalInvoiceMasterData.otherDetail2,
        otherDetail3: this.hospitalInvoiceMasterData.otherDetail3,
        otherDetail4: this.hospitalInvoiceMasterData.otherDetail4,
        otherDetail5: this.hospitalInvoiceMasterData.otherDetail5,
        otherDetail6: this.hospitalInvoiceMasterData.otherDetail6,
        isActive: this.hospitalInvoiceMasterData.isActive ?? 1,
        actionUser: this.User.userId.toString(),
      };

      this.HospitalInvoiceMasterService
        .HospitalInvoiceMaster_Update(payload)
        .subscribe({
          next: (res) => {
            // Reflect updated status locally
            this.hospitalInvoiceMasterData = { ...this.hospitalInvoiceMasterData!, status: "Paid" };
            this.isInvoiceAlreadyPaid = true;

            this.isLoading = false;
            this.toastr.success("Cash payment recorded. Invoice marked as Paid ✅");
            // this.redirectAfterPayment();
          },
          error: (err) => {
            console.error("Invoice update error:", err);
            this.isLoading = false;
            this.toastr.error("Failed to update invoice. Please try again.");
          },
        });
    } else if(isSchool && this.schoolInvoiceMasterData) {
      this.isLoading = true;

      const payload: SchoolInvoiceMasterUpdateRequestDTO = {
        invoiceId: this.schoolInvoiceMasterData.invoiceId,
        schoolId: this.schoolInvoiceMasterData.schoolId,
        billedTo: this.schoolInvoiceMasterData.billedTo,
        invoiceDate: this.schoolInvoiceMasterData.invoiceDate,
        invoiceAmount: this.schoolInvoiceMasterData.invoiceAmount,
        status: "Paid",
        guardian1: this.schoolInvoiceMasterData.guardian1,
        guardian2: this.schoolInvoiceMasterData.guardian2,
        remarks: this.schoolInvoiceMasterData.remarks,
        prrn: this.schoolInvoiceMasterData.prrn,
        invoiceNumber: this.schoolInvoiceMasterData.invoiceNumber,
        otherDetail1: this.schoolInvoiceMasterData.otherDetail1,
        otherDetail2: this.schoolInvoiceMasterData.otherDetail2,
        otherDetail3: this.schoolInvoiceMasterData.otherDetail3,
        otherDetail4: this.schoolInvoiceMasterData.otherDetail4,
        otherDetail5: this.schoolInvoiceMasterData.otherDetail5,
        otherDetail6: this.schoolInvoiceMasterData.otherDetail6,
        isActive: this.schoolInvoiceMasterData.isActive ?? 1,
        actionUser: this.User.userId.toString(),
        dueDate: new Date(),
      };

      this.SchoolInvoiceMasterService
        .SchoolInvoiceMaster_Update(payload)
        .subscribe({
          next: (res) => {
            // Reflect updated status locally
            this.schoolInvoiceMasterData = { ...this.schoolInvoiceMasterData!, status: "Paid" };
            this.isInvoiceAlreadyPaid = true;

            this.isLoading = false;
            this.toastr.success("Cash payment recorded. Invoice marked as Paid ✅");
            // this.redirectAfterPayment();
          },
          error: (err) => {
            console.error("Invoice update error:", err);
            this.isLoading = false;
            this.toastr.error("Failed to update invoice. Please try again.");
          },
        });
    }
    else {
      // Non-hospital or invoice not loaded — just show success
      this.toastr.success("Cash Payment Recorded ✅");
      // this.redirectAfterPayment();
    }
  }
    private redirectAfterPayment(): void {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
    } else {
      window.history.back();
    }
  }

get payableAmountForPayment(): number {
  return Number(this.quickLoanData?.loanamt || 0);
}

get shouldShowPayNow(): boolean {
  return Number(this.payableAmountForPayment || 0) > 0;
}

get isPayButtonDisabled(): boolean {
  return this.isLoading;
}

goBack(): void {
  this.redirectAfterPayment();
}
}
